import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PoModule } from '@po-ui/ng-components';
import { HomeModule } from './home/home.module';
import { CoreModule } from './core/core.module';
import { PoTemplatesModule } from '@po-ui/ng-templates';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RpasModule } from './home/rpas/rpas.module';
import { RpasRelatorioModule } from './home/rpas/relatorio/rpas-relatorio.module';
import { RpasRelatorioPendenciasModule } from './home/rpas/relatorio-pendencias/rpas-relatorio-pendencias.module';
import { RpasAnalisePendenciaModule } from './home/rpas/analise-pendencia/rpas-analise-pendencia.module';
import { CertidoesModule } from './home/certidoes/certidoes.module';
import { CertidoesRelatorioModule } from './home/certidoes/relatorio/certidoes-relatorio.module';
import { LancamentosModule } from './home/contabil-outros/lancamentos/lancamentos.module';
import { DpFichasModule } from './home/dp/dp-fichas/dp-fichas.module';
import { DpRubricasModule } from './home/dp/dp-rubricas/dp-rubricas.module';
import { DpLancamentoRubricasModule } from './home/dp/dp-lancamento-rubricas/dp-lancamento-rubricas.module';
import { RelatorioConvenioModule } from './home/rh/relatorio-convenio/relatorio-convenio.module';
import { SimplesNacionalModule } from './home/fiscal/simples-nacional/simples-nacional.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    PoModule,
    HomeModule,
    CoreModule,
    PoTemplatesModule,
    RpasModule,
    RpasRelatorioModule,
    RpasRelatorioPendenciasModule,
    RpasAnalisePendenciaModule,
    CertidoesModule,
    CertidoesRelatorioModule,
    LancamentosModule,
    DpFichasModule,
    DpRubricasModule,
    DpLancamentoRubricasModule,
    RelatorioConvenioModule,
    SimplesNacionalModule
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  bootstrap: [AppComponent]
})
export class AppModule { }
